/** @jsx jsx */
import { jsx } from '@emotion/core';

import * as S from './styles';

interface IContainer {
  children: any;
}

export const Container = ({ children }: IContainer) => (
  <S.Container>{children}</S.Container>
);

interface IPageContainer {
  children: any;
}

export const PageContainer = ({ children }: IPageContainer) => (
  <S.PageContainer>{children}</S.PageContainer>
);
